// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2041":"5fe028b52e13d7a937b4","5802":"36a9971f58c808c4a974"}[chunkId] + ".js";
};